export {default as withLocaleServerSideProps} from "./withLocaleServerSideProps";
export {default as localeServerSideProps} from "./localeServerSideProps";
